import { render, staticRenderFns } from "./TeeSlider.vue?vue&type=template&id=6cabf4d9&scoped=true&"
import script from "./TeeSlider.vue?vue&type=script&lang=js&"
export * from "./TeeSlider.vue?vue&type=script&lang=js&"
import style0 from "./TeeSlider.vue?vue&type=style&index=0&id=6cabf4d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cabf4d9",
  null
  
)

export default component.exports